// ==============================================================================//
// Restricting action Buttons to stick to bottom of the card | Grid view only - V
// Concerned CSS added to custom.css
// ==============================================================================//
document.addEventListener("DOMContentLoaded", function() {
  const params = new URLSearchParams(window.location.search);
  const view = params.get("grid_list");

  document.body.classList.remove("view-grid", "view-list"); // reset first
  if (view === "grid-view") {
    document.body.classList.add("view-grid");
  } else if (view === "list-view") {
    document.body.classList.add("view-list");
  } else if(view == null){  
    // default case for the first load when no url parameter is passed
    document.body.classList.add("view-grid");
  }
});

///////////////////
// Custom ATC button on product page (Top of Description) - V - updated 06 03 2026
///////////////////

document.addEventListener('DOMContentLoaded', function() {

  if (!window.location.pathname.includes('/products/')) return;
  
  var customBtn = document.querySelector('[data-add-to-cart-custom]');
  if(!customBtn) return;

  var defaultBtn = document.querySelector('div.product-form--atc div.product-form__action-wrapper button[type="submit"]');
  if(!defaultBtn) return;
  
  // console.log("VARUN: All return statements bypassed");
  
  // Show same button text
  var defaultBtnLabelText = document.querySelector('div.product-form--atc div.product-form__action-wrapper button[type="submit"] span.atc-button--text').innerHTML.trim();
  document.querySelector('[data-add-to-cart-custom] span.atc-button--text').textContent = defaultBtnLabelText;

  if((defaultBtnLabelText.toLowerCase() == "add to cart") || (defaultBtnLabelText.toLowerCase() == "pre-order")){
    if (customBtn && defaultBtn) {
      customBtn.addEventListener('click', function(e) {

        // Prevent duplicate triggers
        if (customBtn.dataset.atcTriggered) return;
        customBtn.dataset.atcTriggered = "true";

        // Add loading state + disabled state
        customBtn.classList.add('loading');
        customBtn.disabled = true;

        defaultBtn.click(); // triggers default add-to-cart logic

        // Manual timeout for loader in case the submission fails
        setTimeout(function() {
          customBtn.classList.remove('loading');
          customBtn.disabled = false;
          customBtn.dataset.atcTriggered = ""; // reset if needed
        }, 8000);
      });
    }
  } else if(defaultBtnLabelText.toLowerCase() == "sold out"){
    customBtn.disabled = true;
    customBtn.classList.add('disabled-custom-btn');
  }
  // else if(defaultBtnLabelText == "Pre-order"){
  //   // customBtn.classList.add('disabled-custom-btn');
  //   //Add Pre order conditions here
  // }
});

// =============================================================//
// Updating Share Cart button styling on Cart page (on load) - V
// =============================================================//
// Share Cart has been reomved. No longer needed.
// document.addEventListener('DOMContentLoaded', function() {
//   const modifyButtonAndSvgCSSRules = () => {
//     let ruleFound = false;
//     for (const sheet of document.styleSheets) {
//       try {
//         for (const rule of sheet.cssRules || []) {
//           if (
//             rule.selectorText &&
//             rule.selectorText.includes('div button.share_cart_btn')
//           ) {
//             // Button rules
//             if (rule.selectorText.includes(':focus') || rule.selectorText.endsWith('.share_cart_btn')) {
//               rule.style.background = '#fff';
//               rule.style.border = 'none';
//               rule.style.color = '#c8102e';
//               rule.style.borderRadius = '3px';
//               rule.style.padding = '0px';
//               ruleFound = true;
//             }
//             // SVG icon rules
//             if (rule.selectorText.includes('svg')) {
//               rule.style.stroke = '#c8102e';
//               rule.style.fill = '#ffffff';
//               ruleFound = true;
//             }
//           }
//         }
//       } catch (e) {
//       }
//     }

//     if (ruleFound) {
//       const hoverStyle = document.createElement('style');
//       hoverStyle.innerHTML = `
//         div button.share_cart_btn:hover {
//           color:rgb(110, 9, 26) !important; 
//           text-decoration: underline;
//         }
//         div button.share_cart_btn:hover svg {
//           stroke:rgb(110, 9, 26) !important;
//         }
//       `;
//       document.head.appendChild(hoverStyle);
//     }
//     return ruleFound;
//   };

//   const timeouts = [1000, 2000, 3000, 4000, 5000, 9000];
//   timeouts.forEach((delay) => {
//     setTimeout(() => {
//       const success = modifyButtonAndSvgCSSRules();
//       if (success) {
//         timeouts.length = 0; // stop future checks once applied
//       }
//     }, delay);
//   });
// });

////////////////////////
// Skipping empty pages on search result page due to excldued tags - V 21 01 2026
///////////////////////

(function () {
  // Run only on /search page
  if (!window.location.pathname.startsWith('/search')) return;

  // Do not run for bots (SEO safe)
  var ua = navigator.userAgent.toLowerCase();
  if (/bot|crawl|slurp|spider|mediapartners/i.test(ua)) return;

  var attempts = 0;
  var maxAttempts = 15; // 1.5 seconds 

  function tryRedirect() {
    attempts++;

    var productGrid = document.querySelector('.productgrid--items');
    if (!productGrid) {
      if (attempts < maxAttempts) {
        return setTimeout(tryRedirect, 100);
      }
      return;
    }

    // Check for visible product cards
    var visibleProducts = productGrid.querySelectorAll(
      '.productgrid--item, .productgrid--item-container, .productitem'
    );

    // If products exist, do nothing
    if (visibleProducts.length > 0) return;

    // Look for pagination next page link
    var paginationContainer = document.querySelector('.pagination--container');
    if (!paginationContainer) {
      if (attempts < maxAttempts) {
        return setTimeout(tryRedirect, 100);
      }
      return;
    }

    var nextPageLink = paginationContainer.querySelector('.pagination--next a');
    if (!nextPageLink) return;

    // Prevent infinite loops on last page
    if (window.location.href === nextPageLink.href) return;

    // Redirect to next page
    window.location.replace(nextPageLink.href);
  }

  document.addEventListener('DOMContentLoaded', function () {
    tryRedirect();
  });
})();

///////////////////////
// Fix applied in product-grid-item.liquid - Second layer of prevention - V 06 03 2026
///////////////////////

// document.addEventListener("DOMContentLoaded",function(){
//   document.querySelectorAll('a[href*="/cart/add"]').forEach(a=>{
//     a.removeAttribute("href");
//   });
// });


////// Enabling Buy Now button on Collections page - 25 03 2026 - V
document.addEventListener('click', function(e) {
  const btn = e.target.closest('[data-buy-now]');
  if (!btn) return;

  e.preventDefault();

  // Prevent double click
  if (btn.disabled) return;

  const variantId = btn.getAttribute('data-variant-id');
  if (!variantId) return;

  // Disable button instantly
  btn.disabled = true;
  btn.classList.add('disabled-custom-btn'); 

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
  .then(() => {
    window.location.href = '/checkout';
  })
  .catch(err => {
    console.error('Buy Now error:', err);

    // Re-enable if something fails
    btn.disabled = false;
    btn.classList.remove('disabled-custom-btn');
  });
});

// ==============================================================================//
// Contact Page ReCaptcha - 15 04 2026 - V
// ==============================================================================//

